export enum UserAction {
  SignUpSuccess = "SignUpSuccess",

  GetRoleSuccess = "GetRoleSuccess",

  GetAudienceSuccess = "GetAudienceSuccess",

  GetUserSuccess = "GetUserSuccess",
  UpdateUserSuccess = "UpdateUserSuccess",

  ResetPasswordSuccess = "ResetPasswordSuccess",

  GetIncomingEmailsSuccess = "GetIncomingEmailsSuccess",

  GetBookmarksSuccess = "GetBookmarksSuccess",
  CreateBookmarkSuccess = "CreateBookmarkSuccess",
  UpdateBookmarkSuccess = "UpdateBookmarkSuccess",
  DeleteBookmarkSuccess = "DeleteBookmarkSuccess",
  SetSelectedBookmark = "SetSelectedBookmark",
  GetManagersSuccess = "GetManagersSuccess",
  SetShowUnlockFullAccess = "SetShowUnlockFullAccess",

  SetNumberFormat = "SetNumberFormat",
  SetHideExtractorGuide = "SetHideExtractorGuide",
  SetHideWelcomePopup = "SetHideWelcomePopup",
  SetOnboardingCompleted = "SetOnboardingCompleted",

  UpdateWorkspaceColumns = "UpdateWorkspaceColumns",
  UpdateAmortizationTableColumns = "UpdateAmortizationTableColumns",
  SetPipelineViewConfig = "SetPipelineViewConfig",

  GetNotificationsSuccess = "GetNotificationsSuccess",

  UpdateNotificationSuccess = "UpdateNotificationSuccess",
  DeleteNotificationSuccess = "DeleteNotificationSuccess",
  CreateNotificationSocket = "CreateNotificationSocket",
  UpdateNotificationsGroupSuccess = "UpdateNotificationsGroupSuccess",
  UpdateAllNotificationsGroupSuccess = "UpdateAllNotificationsGroupSuccess",
  DeleteNotificationsGroupSuccess = "DeleteNotificationsGroupSuccess",
  ReceiveUnreadNotifications = "ReceiveUnreadNotifications",

  SetFilterByDeal = "SetFilterByDeal",

  IncrementNumberOfDeals = "IncrementNumberOfDeals",
  DecrementNumberOfDeals = "DecrementNumberOfDeals",
  SetFilesFilters = "SetFilesFilters",
  SetFileRepoColumns = "SetFileRepoColumns",
  SetPortfolioConstruct = "SetPortfolioConstruct",

  SetDigestSettings = "SetDigestSettings"
}

export enum DealAction {
  GetDealByIdSuccess = "GetDealByIdSuccess",

  GetDealAssetsClasses = "GetDealAssetsClasses",

  UploadLoadingProgress = "UploadLoadingProgress",
  UploadLoadingSuccess = "UploadLoadingFailure",
  UploadLoadingFailure = "UploadLoadingFailure",

  HandleFileSuccess = "HandleFileSuccess",

  //------------------------------------ Deal form -------------------------
  GetFormsSuccess = "GetFormsSuccess",
  CreateFormSuccess = "CreateFormSuccess",
  UpdateFormSuccess = "UpdateFormSuccess",
  DeleteFormSuccess = "DeleteFormSuccess",

  GetDealFormRequest = "GetDealFormRequest",
  GetDealFormSuccess = "GetDealFormSuccess",
  GetDealFormFailure = "GetDealFormFailure",

  UpdateDealFormQuestion = "UpdateDealFormQuestion",
  UpdateDealFormQuestionOrder = "UpdateDealFormQuestionOrder",

  ClearDealForm = "ClearDealForm",

  PublishDealFormAnswerSuccess = "PublishDealFormAnswerSuccess",
  PublishDealFormAnswerSocket = "PublishDealFormAnswerSocket",

  ClearDealFormAnswerSuccess = "ClearDealFormAnswerSuccess",

  RequestRefreshDealFormSocket = "RequestRefreshDealFormSocket",

  GetDealFormAnswerSuccess = "GetDealFormAnswerSuccess",

  SetDealFormDraft = "SetDealFormDraft",

  DiscardDealFormDraft = "DiscardDealFormDraft",

  AddUserDealForm = "AddUserDealForm",

  // ------------------------------ End of deal form -----------------

  UpdateDealSuccess = "UpdateDealSuccess",

  UpdateCapitalSeekerSuccess = "UpdateCapitalSeekerSuccess",

  DealInvalidate = "DealInvalidate",

  GetDealStatusesSuccess = "GetDealStatusesSuccess",

  UpdateDealStatusSuccess = "UpdateDealStatusSuccess",

  GetAssetClassesSuccess = "GetAssetClassesSuccess",

  HandleEmailSuccess = "HandleEmailSuccess",

  GetFilesSuccess = "GetFilesSuccess",
  GetFileMetaSuccess = "GetFileMetaSuccess",
  UpdateFileMetaSuccess = "UpdateFileMetaSuccess",
  InvalidateFileMeta = "InvalidateFileMeta",
  RemoveFilesFromStore = "RemoveFilesFromStore",

  GetFolderMetaSuccess = "GetFolderMetaSuccess",
  AppendFolderMetaDetails = "AppendFolderMetaDetails",
  InvalidateFolderMeta = "InvalidateFolderMeta",

  GetFoldersSuccess = "GetFoldersSuccess",
  CreateFolderSuccess = "CreateFolderSuccess",
  UpdateFolderSuccess = "UpdateFolderSuccess",
  DeleteFolderSuccess = "DeleteFolderSuccess",
  ImportFoldersSuccess = "ImportFoldersSuccess",

  GetEmailMetaSuccess = "GetEmailMetaSuccess",
  InvalidateEmailMeta = "InvalidateEmailMeta",
  GetEmailsSuccess = "GetEmailsSuccess",

  GetNewsMetaSuccess = "GetNewsMetaSuccess",
  InvalidateNewslMeta = "InvalidateNewsMeta",

  GetInvestorsSuccess = "GetInvestorsSuccess",
  CreateInvestorSuccess = "CreateInvestorSuccess",
  UpdateInvestorSuccess = "UpdateInvestorSuccess",
  DeleteInvestorSuccess = "DeleteInvestorSuccess",

  HandleNoteSuccess = "HandleNoteSuccess",
  GetNotesSuccess = "GetNotesSuccess",

  GetNoteMetaSuccess = "GetNoteMetaSuccess",
  InvalidateNoteMeta = "InvalidateNoteMeta",

  SetNoteLockSocket = "SetNoteLockSocket",

  CreateRoundSuccess = "CreateRoundSuccess",
  DeleteRoundSuccess = "DeleteRoundSuccess",
  UpdateRoundSuccess = "UpdateRoundSuccess",
  GetRoundsSuccess = "GetRoundsSuccess",

  CreateCommitmentSuccess = "CreateCommitmentSuccess",
  DeleteCommitmentSuccess = "DeleteCommitmentSuccess",
  UpdateCommitmentSuccess = "UpdateCommitmentSuccess",
  CreateFirstCommitmentSuccess = "CreateFirstCommitmentSuccess",

  GetMeasureParametersSuccess = "GetMeasuresParametersSuccess",

  UpdateQueries = "UpdateQueries",

  ImportCommitmentSuccess = "ImportCommitmentSuccess",

  SetLogoToSave = "SetLogoToSave",
  SaveLogoSuccess = "SaveLogoSuccess",
  DeleteLogoSuccess = "DeleteLogoSuccess",

  SetHierarchyPanelOpen = "SetHierarchyPanelOpen",

  SetCharacteristicsManageData = "SetCharacteristicsManageData",

  SetReachOutManage = "SetReachOutManage",

  GetMeasuresSuccess = "GetMeasuresSuccess",
  CreateMeasureSuccess = "CreateMeasureSuccess",
  UpdateMeasureSuccess = "UpdateMeasureSuccess",
  DeleteMeasureSuccess = "DeleteMeasureSuccess",

  SetMonitoringDataFilters = "SetMonitoringDataFilters",

  GetOpportunitiesSuccess = "GetOpportunitiesSuccess",

  GetDealChunksSuccess = "GetDealChunksSuccess", // Chunks are files, folders, e.t.c

  // CreateDocumentSuccess = "CreateDocumentSuccess",
  // // UpdateDocumentSuccess = "UpdateDocumentSuccess",
  // DeleteDocumentSuccess = "DeleteDocumentSuccess",
  // GetDocumentContentSuccess = "GetDocumentContentSuccess",

  // AddDocumentSection = "AddDocumentSection",
  // UpdateDocumentSection = "UpdateDocumentSection",
  // DeleteDocumentSection = "DeleteDocumentSection",

  // AddDocumentQuestion = "AddDocumentQuestion",
  // UpdateDocumentQuestion = "UpdateDocumentQuestion",
  // DeleteDocumentQuestion = "DeleteDocumentQuestion",

  // AddDocumentAnswer = "AddDocumentAnswer",
  // UpdateDocumentAnswer = "UpdateDocumentAnswer",
  // DeleteDocumentAnswer = "DeleteDocumentAnswer",

  // UpdateDocumentSections = "UpdateDocumentSections",

  // ReorderDocumentSections = "ReorderDocumentSections",

  CreateCrunchbaseSuccess = "CreateCrunchbaseSuccess",

  GetDashboardSharesSuccess = "GetDashboardSharesSuccess",
  GetDealFiltersSuccess = "GetDealFiltersSuccess",

  UploadFundFilesSuccess = "UploadFundFilesSuccess",

  UpdateDealCryptoCoinIcon = "UpdateDealCryptoCoinIcon",
  UpdateDealNullifyCommitment = "UpdateDealNullifyCommitment",

  SetDealsQueryCubic = "SetDealsQueryCubic",
  SetInvestorsViewChart = "SetInvestorsViewChart",
  SetInvestmentDetailsChart = "SetInvestmentDetailsChart",

  GetDealRoundsWithInvestorsSuccess = "GetDealRoundsWithInvestorsSuccess",

  PatchFolderMetaDetail = "PatchFolderMetaDetail",
  GetDocumentTypesSuccess = "GetDocumentTypesSuccess"
}

export enum CommentsAction {
  GetCommentRequest = "GetCommentRequest",
  GetCommentSuccess = "GetCommentSuccess",
  GetCommentFailure = "GetCommentFailure",

  CreateCommentSuccess = "CreateCommentSuccess",

  UpdateCommentSuccess = "UpdateCommentSuccess",

  DeleteCommentSuccess = "DeleteCommentSuccess",

  CreateCommentSocket = "CreateCommentSocket",
  UpdateCommentSocket = "UpdateCommentSocket",
  DeleteCommentSocket = "DeleteCommentSocket"
}

export enum AuthAction {
  AuthRequest = "AutRequest",
  SessionSuccess = "SessionSuccess",
  AuthFailure = "AuthFailure",
  RemoveToken = "RemoveToken",
  Logout = "Logout"
}

export enum ViewAction {
  CommentsScroll = "CommentsScroll",
  ScrollToAnswer = "ScrollToAnswer",
  SetShareDialog = "SetShareDialog",
  SetWindowSize = "SetWindowSize",
  SetLeftSlider = "SetLeftSlider",
  ScrollToQuestion = "ScrollToQuestion",
  EmailBoxUpdate = "EmailBoxUpdate",
  SetError409 = "SetError409",
  SetDealRedirect = "SetDealRedirect",
  SetCrucnbaseDrawerState = "SetCrucnbaseDrawerState",
  SetCryptoCurrencyDrawerState = "SetCryptoCurrencyDrawerState",
  SetCreateManyMeasureData = "SetCreateManyMeasureData",
  SetSelectedQuestion = "SetSelectedQuestion",
  SetQuickViewAddNewLine = "SetQuickViewAddNewLine",
  SetIsDealCharBarOpen = "SetIsDealCharBarOpen",
  SetSidebarState = "SetSidebarState"
}

export enum ReportsAction {
  GetMetaSuccess = "GetMetaSuccess",
  GetDataSuccess = "GetDataSuccess",
  SetQueries = "SetQueries",
  ReplaceQueries = "ReplaceQueries",
  SetGraphFormat = "SetGraphFormat",
  clearTableData = "clearTableData",
  ToggleExpandRow = "ToggleExpandRow",
  SetChartType = "SetChartType",
  SetGraphChartType = "SetGraphChartType",
  SetConfig = "SetConfig",
  ResetConfig = "ResetConfig",
  SetQuickViewMeta = "SetQuickViewMeta",
  UpdateConfig = "UpdateConfig",
  RefetchReport = "RefetchReport",
  SetIgnoreDefaultView = "SetIgnoreDefaultView",
  SetQuickViewQueries = "SetQuickViewQueries",
  SetIsHedgeFunds = "SetIsHedgeFunds",
  SetCubic = "SetCubic",
  SetCorrelationMatrixSettings = "SetCorrelationMatrixSettings"
}

export enum TaskManageAction {
  GetTasksSuccess = "GetTasksSuccess",
  // GetTaskSuccess = "GetTaskSuccess",
  CreateTaskSuccess = "CreateTaskSuccess",
  UpdateTaskSuccess = "UpdateTaskSuccess",
  DeleteTaskSuccess = "DeleteTaskSuccess",
  SetCreate = "SetCreate",
  ClearTasks = "ClearTasks",
  GetDealsSuccess = "GetDealsSuccess"
}

export enum TaggerAction {
  ChangeDeal = "ChangeDeal",
  ChangeDealTitle = "ChangeDealTitle",
  ChangeFolder = "ChangeFolder",
  ChangeDocumentData = "ChangeDocumentData",
  ChangeDocumentFileData = "ChangeDocumentFileData",
  AddFiles = "AddFiles",
  AddDocuments = "AddDocuments",
  FilesAnalyzingStatus = "FilesAnalyzingStatus",
  FilesAnalysisLoading = "FilesAnalysisLoading",
  UpdatePolygons = "UpdatePolygons",
  PolygonsError = "PolygonsError",
  TagPhrase = "TagPhrase",
  AddTag = "AddTag",
  AddTags = "AddTags",
  AddTagSuccess = "AddTagSuccess",
  AddTagFailure = "AddTagFailure",
  SetTags = "SetTags",
  EditTag = "EditTag",
  DeleteTag = "DeleteTag",
  SplitTagByCommitments = "SplitTagByCommitments",
  ResetTagger = "ResetTagger",
  GetDealRounds = "GetDealRounds",
  SetCurrentPageForDocument = "SetCurrentPageForDocument"
}

export enum DataRoomsAction {
  GetConnectionsSucccess = "GetConnectionsSucccess",
  GetConnectionSuccess = "GetConnectionSuccess",
  DeleteConnectionSuccess = "DeleteConnectionSuccess",
  UpdateRelationSuccess = "UpdateRelationSuccess",
  UpdateConnectionSuccess = "UpdateConnectionSuccess",
  SaveConnectionPreview = "SaveConnectionPreview",
  SetConnectMessage = "SetConnectMessage",
  SetConnectMessageTimeout = "SetConnectMessageTimeout",
  SetPlatforms = "SetPlatforms"
}

export enum CharacteristicsAction {}

export enum DocumentsAction {
  GetDocumentsSuccess = "GetDocumentsSuccess",
  GetPaginatedDocumentsSuccess = "GetPaginatedDocumentsSuccess",
  UpdateDocumentSuccess = "UpdateDocumentSuccess",
  InvalidateDocuments = "InvalidateDocuments",
  CreateDocumentSuccess = "CreateDocumentSuccess",
  // UpdateDocumentSuccess = "UpdateDocumentSuccess",
  DeleteDocumentSuccess = "DeleteDocumentSuccess"
  // GetDocumentContentSuccess = "GetDocumentContentSuccess",

  // AddDocumentSection = "AddDocumentSection",
  // UpdateDocumentSection = "UpdateDocumentSection",
  // DeleteDocumentSection = "DeleteDocumentSection",

  // AddDocumentQuestion = "AddDocumentQuestion",
  // UpdateDocumentQuestion = "UpdateDocumentQuestion",
  // DeleteDocumentQuestion = "DeleteDocumentQuestion",

  // AddDocumentAnswer = "AddDocumentAnswer",
  // UpdateDocumentAnswer = "UpdateDocumentAnswer",
  // DeleteDocumentAnswer = "DeleteDocumentAnswer",

  // UpdateDocumentSections = "UpdateDocumentSections",

  // ReorderDocumentSections = "ReorderDocumentSections",

  // HandleDocumentFileSuccess = "HandleDocumentFileSuccess",

  // UpdateDocumentSectionData = "UpdateDocumentSectionData",

  // UpdateDocumentQuestionAndAnswersAi = "UpdateDocumentQuestionAndAnswersAi"
}
